const utils = require('frontend-controller/lib/utils')

module.exports = {
    config: {
        minStartHour: 0,
        maxStartHour: undefined,
        minStartHourIncrement: 1,
        hideMaxStartHourPriceField: true,
        ensureMaxStartHourField: true,

        priceConfig: {},
        priceConfigs: {},
        showCommission: false,
    },

    model: {
        dataJSON: [],
        lastFocusOn: {
            // fieldKey: undefined, // dataJSON index
            // fieldCode: '', // startHour, price
        }
    },

    events: {
        action: {
            type: 'click',
            selector: 'button',
            action(event){
                event.preventDefault()
                event.stopImmediatePropagation()

                const $target = $(event.target).closest('button')
                const fieldType = $target.data('fieldType')
                const fieldKey = $target.closest('.entry').data('fieldKey')

                if(fieldKey !== undefined){
                    if(fieldType === 'showInsert'){
                        event.data.component.showInsert(fieldKey)
                    }
                    if(fieldType === 'delete'){
                        event.data.component.delete(fieldKey)
                    }
                }
            }
        },

        selectOnClick: {
            type: 'click',
            selector: 'input[type="text"]',
            action(event){
                event.preventDefault()
                event.stopImmediatePropagation()

                const $target = $(event.target).closest('input[type="text"]')
                if($target.length){
                    $target[0].select()
                }
            },
        },

        focusTracker: {
            type: 'focusin',
            selector: '.entry input',
            action(event){
                const $target = $(event.target).closest('input')
                const fieldCode = $target.data('fieldCode')
                const fieldKey = $target.closest('.entry').data('fieldKey')

                if(fieldCode !== undefined && fieldKey !== undefined){
                    event.data.component.model.lastFocusOn = {
                        fieldKey,
                        fieldCode,
                    }
                }
            }
        }
    },

    methods: {
        dataDealer(){
            const priceConfigs = this.config.priceConfigs = this.getResourceRegisterContent('priceConfigs') || {}
            const {employeeID} = this.getResourceRegisterContent('parentEntity') || {}
            if(employeeID && this.scope === 'office'){
                this.config.showCommission = true
            }

            if(utils.collectionSize(priceConfigs.data) > 0) {
                this.config.priceConfig = (priceConfigs.data[0] || {}).attributes || {}
            }

            this.sanitizeConfig()
            this.sanitizeData()
        },

        sanitizeConfig(){
            const fieldConfig = this.model.config || {}

            if(fieldConfig.minStartHour !== undefined){
                this.config.minStartHour = fieldConfig.minStartHour
            } else if((((fieldConfig.fields || {}).startHour || {}).format || {}).min !== undefined){
                this.config.minStartHour = fieldConfig.fields.startHour.format.min
            }
            if(fieldConfig.maxStartHour !== undefined){
                this.config.maxStartHour = fieldConfig.maxStartHour
            } else if((((fieldConfig.fields || {}).startHour || {}).format || {}).max !== undefined){
                this.config.maxStartHour = fieldConfig.fields.startHour.format.max
            }

            if(this.config.minStartHour !== undefined || this.config.maxStartHour !== undefined){
                fieldConfig.fields                      = fieldConfig.fields || {}
                fieldConfig.fields.startHour            = fieldConfig.fields.startHour || {}
                fieldConfig.fields.startHour.format     = fieldConfig.fields.startHour.format || {}

                if(this.config.minStartHour !== undefined){
                    fieldConfig.fields.startHour.format.min = this.config.minStartHour
                }
                if(this.config.maxStartHour !== undefined){
                    fieldConfig.fields.startHour.format.max = this.config.maxStartHour
                }
            }

            if(fieldConfig.minStartHourIncrement > 0){
                this.config.minStartHourIncrement = fieldConfig.minStartHourIncrement
            }

            if(fieldConfig.hideMaxStartHourPriceField !== undefined){
                this.config.hideMaxStartHourPriceField = !!fieldConfig.hideMaxStartHourPriceField
            }
            if(fieldConfig.ensureMaxStartHourField !== undefined){
                this.config.ensureMaxStartHourField = !!fieldConfig.ensureMaxStartHourField
            }
            if(this.config.maxStartHour === undefined){
                this.config.hideMaxStartHourPriceField = false
                this.config.ensureMaxStartHourField = false
            }
        },

        sanitizeData(lastChangedFieldKey, lastChangedFieldCode){
            const dataJSON = this.model.dataJSON = (this.model.dataJSON || []).filter(value => !!value)

            let lastChangedStartHour, entryChangedBySanitize = false
            if(lastChangedFieldKey !== undefined){
                entryChangedBySanitize = this.sanitizeEntry(dataJSON[lastChangedFieldKey] || {}, lastChangedFieldCode)
                lastChangedStartHour = (dataJSON[lastChangedFieldKey] || {}).startHour || undefined
            }

            const actualDataHash = utils.collectionMD5(dataJSON)
            let forceChange = false

            dataJSON.sort((a, b) => {
                if(a.startHour < b.startHour) return -1;
                if(a.startHour > b.startHour) return 1;
                return 0;
            })
            const sortedDataHash = utils.collectionMD5(dataJSON)
            const hasBeenSorted = actualDataHash !== sortedDataHash

            // remove multiple maxStartHour-Entries
            if(this.config.maxStartHour !== undefined){
                let maxElementFound = false
                utils.forEachReverse(dataJSON, (entry, entryFieldKey) => {
                    if(entry.startHour >= this.config.maxStartHour){
                        if(maxElementFound){
                            dataJSON.splice(entryFieldKey, 1)
                        } else {
                            maxElementFound = true
                        }
                    }
                })
            }


            const firstEntry = dataJSON[0] || {}
            let lastEntry = dataJSON[dataJSON.length - 1] || {}
            // add new last entry if necessary
            if(
                dataJSON.length < 1
                ||
                (
                    lastEntry.price &&
                    (
                        this.config.maxStartHour === undefined
                        ||
                        lastEntry.startHour < this.config.maxStartHour
                    )
                )
            ){
                let startHour = this.config.minStartHour
                if(lastEntry.startHour !== undefined){
                    startHour = lastEntry.startHour + this.config.minStartHourIncrement
                }
                dataJSON.push({
                    startHour,
                })

                if(!hasBeenSorted){
                    this.model.lastFocusOn = {
                        fieldKey:   dataJSON.length - 1,
                        fieldCode:  'startHour'
                    }
                }
            }
            lastEntry = dataJSON[dataJSON.length - 1] || {}
            if(this.config.ensureMaxStartHourField && lastEntry.startHour < this.config.maxStartHour){
                dataJSON.push({
                    startHour: this.config.maxStartHour
                })
            }

            // add new first entry if necessary
            if(firstEntry.startHour > this.config.minStartHour){
                dataJSON.unshift({
                    startHour: this.config.minStartHour
                })
                this.model.lastFocusOn = {
                    fieldKey:   0,
                    fieldCode:  'price'
                }
            }
            // focus price field in case of only one field available
            if(dataJSON.length === 1){
                this.model.lastFocusOn = {
                    fieldKey:   0,
                    fieldCode:  'price'
                }
            } else if(hasBeenSorted && lastChangedStartHour !== undefined){
                const lastChangedFieldKey = utils.indexOf(dataJSON, entry => entry.startHour === lastChangedStartHour)
                if(lastChangedFieldKey > -1){
                    this.model.lastFocusOn = {
                        fieldKey:   lastChangedFieldKey,
                        fieldCode:  'price'
                    }
                }
            }

            lastEntry = dataJSON[dataJSON.length - 1] || {}
            if(this.config.hideMaxStartHourPriceField){
                if(lastEntry.startHour >= this.config.maxStartHour){
                    delete lastEntry.price

                    // don't keep focus on startHour field of maxStartHour-Entry.
                    if(dataJSON.length - 1 == lastChangedFieldKey){
                        this.model.lastFocusOn = {}
                    }
                } else {
                    lastEntry.price = 0

                    if(dataJSON.length - 1 == lastChangedFieldKey){
                        this.model.lastFocusOn.fieldCode = 'price'
                    }
                }
            }

            const newDataHash = utils.collectionMD5(dataJSON)
            return forceChange || actualDataHash !== newDataHash || entryChangedBySanitize
        },

        sanitizeEntry(entry, fieldCode){
            if(!entry){
                return false
            }

            const priceConfig = this.config.priceConfig || {}

            if(fieldCode === 'price'){
                if(entry.price){
                    entry.priceCommission = utils.number.round((entry.price || 0) * (100 + (priceConfig.externalEmployeeCommissionPercentage || 0)) / 100, 2)
                } else {
                    entry.priceCommission = null
                }

                // recalculate price after round off
                fieldCode = 'priceCommission'
            }

            if(fieldCode === 'priceCommission'){
                if(entry.priceCommission){
                    entry.price = utils.number.round((entry.priceCommission || 0) * 100 / (100 + (priceConfig.externalEmployeeCommissionPercentage || 0)), 10)
                } else {
                    entry.price = null
                }

                return true
            }

            return false
        },

        showInsert(fieldKey){
            if(fieldKey !== undefined){
                const entry = (this.model.dataJSON || [])[fieldKey]
                if(entry){
                    const startHour = entry.startHour
                    const prevEntry = this.model.dataJSON[fieldKey - 1] || {}
                    const prevStartHour = prevEntry.startHour

                    const newEntry = {
                        startHour: this.config.minStartHour,
                    }
                    if(fieldKey < 1){
                        this.model.lastFocusOn = {
                            fieldKey,
                            fieldCode: 'price'
                        }
                    } else if(startHour !== undefined && prevStartHour !== undefined){
                        newEntry.startHour = prevStartHour + (Math.abs(startHour - prevStartHour) / 2)

                        this.model.lastFocusOn = {
                            fieldKey,
                            fieldCode: 'startHour'
                        }
                    }

                    this.model.dataJSON.splice(fieldKey, 0, newEntry)
                    this.refreshScale()
                }
            }
        },

        delete(fieldKey){
            if(fieldKey !== undefined){
                const entry = (this.model.dataJSON || [])[fieldKey]
                if(entry){
                    this.model.dataJSON.splice(fieldKey, 1)

                    let nextFieldKey = fieldKey
                    if(this.model.dataJSON.length <= fieldKey){
                        nextFieldKey = this.model.dataJSON.length - 1
                    }

                    if(!this.sanitizeData()){
                        this.model.lastFocusOn = {
                            fieldKey: nextFieldKey,
                            fieldCode: 'startHour'
                        }
                    }

                    this.refreshScale()
                }
            }
        },

        async refreshScale(){
            await this.refresh(false)
            const focus = this.model.lastFocusOn
            if(focus.fieldKey !== undefined && focus.fieldCode !== undefined){
                this.$.find(`.entry[data-field-key="${focus.fieldKey}"] input[data-field-code="${focus.fieldCode}"]`).focus().select()
            }
        }
    },

    hooks: {
        onChildChanged: function($element, options){
            const {fieldCode, fieldKey, value} = options || {}

            if(fieldKey !== undefined && fieldCode){
                this.model.dataJSON[fieldKey] = {
                    ...(this.model.dataJSON[fieldKey] || {}),
                    [fieldCode]: value
                }

                if(this.sanitizeData(fieldKey, fieldCode)){
                    this.refreshScale()
                }

                this.triggerClosest('onChildChanged', {
                    fieldCode:  this.model.fieldCode,
                    value:      this.model.dataJSON || []
                });
            }
        }
    }
}